<template>
  <div class="mypooq-inner-wrap">
    <div class="title">
      <h3 class="title-area" tabindex="0">좋아요한 채널</h3>
    </div>
    <section>
      <div class="mypooq-info-body">
        <like-list viewMode="live" :showRecommend="showRecommend"/>
        <recommend-channel v-if="isShowRecommend"/>
      </div>
    </section>
  </div>
</template>

<script>
import LikeList from '@/components/mypooq/LikeList'
import RecommendChannel from '@/components/mypooq/RecommendChannel'

export default {
  components: {
    LikeList,
    RecommendChannel
  },
  data () {
    return {
      isShowRecommend: false
    }
  },
  methods: {
    showRecommend () {
      this.isShowRecommend = true
    }
  }
}
</script>
